<template>
  <div
    class="px-4 py-5 lg:px-10 lg:py-5 bg-white border-b border-secondary-heavy"
  >
    <div class="flex justify-between items-center">
      <div class="lg:hidden flex items-center">
        <button class="btn-secondary px-2.5" @click="props.openSidebar()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M3.33333 5.00002C3.33333 4.77901 3.42113 4.56705 3.57741 4.41076C3.73369 4.25448 3.94565 4.16669 4.16666 4.16669H15.8333C16.0543 4.16669 16.2663 4.25448 16.4226 4.41076C16.5789 4.56705 16.6667 4.77901 16.6667 5.00002C16.6667 5.22103 16.5789 5.433 16.4226 5.58928C16.2663 5.74556 16.0543 5.83335 15.8333 5.83335H4.16666C3.94565 5.83335 3.73369 5.74556 3.57741 5.58928C3.42113 5.433 3.33333 5.22103 3.33333 5.00002ZM3.33333 10C3.33333 9.77901 3.42113 9.56705 3.57741 9.41076C3.73369 9.25448 3.94565 9.16669 4.16666 9.16669H15.8333C16.0543 9.16669 16.2663 9.25448 16.4226 9.41076C16.5789 9.56705 16.6667 9.77901 16.6667 10C16.6667 10.221 16.5789 10.433 16.4226 10.5893C16.2663 10.7456 16.0543 10.8334 15.8333 10.8334H4.16666C3.94565 10.8334 3.73369 10.7456 3.57741 10.5893C3.42113 10.433 3.33333 10.221 3.33333 10ZM4.16666 14.1667C3.94565 14.1667 3.73369 14.2545 3.57741 14.4108C3.42113 14.567 3.33333 14.779 3.33333 15C3.33333 15.221 3.42113 15.433 3.57741 15.5893C3.73369 15.7456 3.94565 15.8334 4.16666 15.8334H15.8333C16.0543 15.8334 16.2663 15.7456 16.4226 15.5893C16.5789 15.433 16.6667 15.221 16.6667 15C16.6667 14.779 16.5789 14.567 16.4226 14.4108C16.2663 14.2545 16.0543 14.1667 15.8333 14.1667H4.16666Z"
              fill="#9B237B"
            />
          </svg>
        </button>
        <div
          class="lg:hidden inline-block h-[50px] min-h-[1em] mx-[14px] w-[1px] self-stretch bg-secondary-heavy"
        ></div>
      </div>
      <!-- hover:!bg-[#EECCE7] -->
      <div class="ml-auto flex items-center">
        <button
          v-if="
            auth.hasRole([ROLES.admin, ROLES.team_leader, ROLES.team_member])
          "
          class="w-[139px] h-[50px] flex items-center justify-center flex-nowrap gap-[4px] p-[16px] rounded-[6px] border-[1px] border-solid border-[#9B237B] bg-[#FBEFF8] hover:bg-[#EECCE7] text-[#9B237B]"
          @click="goto"
        >
          <Emergency_reqIcon class="min-w-[20px] min-h-[20px]" />
          <span class="ButtonM">
            เหตุฉุกเฉิน ( {{ notificationCount || "0" }} )
          </span>
        </button>
        <notiIcon
          @click="openNotification"
          class="ml-[14px] cursor-pointer"
          :class="
            newNotification
              ? 'text-[#9B237B] hover:text-[#841D69]'
              : 'text-[#B7B2B5] hover:text-[#C479B1]'
          "
        />
        <div
          class="inline-block h-[50px] min-h-[1em] mx-[14px] w-[1px] self-stretch bg-secondary-heavy"
        ></div>
        <div class="flex items-center gap-2.5 ml-[10px] relative">
          <div
            class="w-10 h-10 flex justify-center items-center bg-soft-pink rounded-full overflow-hidden border border-[#C3C3C3]"
          >
            <img
              :src="profileData.image || defaultUserImage"
              class="object-cover bg-soft-pink"
              :class="{ 'w-6 h-6': !profileData.image }"
              @click="profileDropdown = !profileDropdown"
            />
            <!-- <PersonIcon class="" /> -->
          </div>
          <button
            id="username"
            class="hidden lg:inline text-primary-dark text-[14px] min-w-24 cursor-pointer"
            @click="profileDropdown = !profileDropdown"
          >
            <div class="flex items-center gap-2">
              <span class="hidden lg:inline font-normal">
                {{ profileData.fullname || "-" }}</span
              >
              <CaretDownIcon
                class="hidden lg:inline duration-100 text-[#7C7379] w-6 h-6"
                :class="profileDropdown ? 'rotate-180' : ''"
              />
            </div>
          </button>
          <div
            v-if="profileDropdown"
            class="absolute right-0 top-[50px] min-w-[180px] sm:min-w-[220px] bg-white shadow-[0px_4px_10px_0px_rgba(0,0,0,0.08)] border border-[#F3F2F2] rounded-md overflow-hidden text-primary-dark text-[14px] z-50"
          >
            <ul>
              <li
                @click="openProfileModal"
                class="p-2 hover:bg-soft-pink hover:text-primary cursor-pointer"
              >
                ข้อมูลส่วนตัว
              </li>
              <li
                @click="
                  ChangePasswordModalRef.openModal();
                  profileDropdown = false;
                "
                class="p-2 hover:bg-soft-pink hover:text-primary cursor-pointer"
              >
                เปลี่ยนรหัสผ่าน
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <ProfileModal
      :profileData="profileData"
      ref="ProfileModalRef"
      @refresh="refetchData"
    />
    <ChangePasswordModal ref="ChangePasswordModalRef" />
    <NotificationModal ref="NotificationModalRef" />
  </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import Emergency_reqIcon from "../../assets/icons/emergency_req.icon.vue";
import notiIcon from "../../assets/icons/noti.icon.vue";
import CaretDownIcon from "../../assets/icons/caretDown.icon.vue";
import defaultUserImage from "@/assets/icons_svg/User.svg";
import { ref, onMounted, onUnmounted, h } from "vue";
import { useAuthStore } from "../../pinia/authStore";
import { useEmcRequestStore } from "@/pinia/emcRequest";
import ProfileModal from "../Modals/ProfileModal.vue";
import ChangePasswordModal from "../Modals/ChangePasswordModal.vue";
import { usePrefixStore } from "../../pinia/prefix";
import { useProductStore } from "@/pinia/product";
import { storeToRefs } from "pinia";
import { useTeamStore } from "../../pinia/team";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";
import ToastNotification from "@/components/Utilities/ToastNotification.vue";

const route = useRoute();
const router = useRouter();
const profileData = ref({});
const profileDropdown = ref(false);
const ProfileModalRef = ref(null);
const ChangePasswordModalRef = ref(null);
const NotificationModalRef = ref(null);
const prefixStore = usePrefixStore();
const productStore = useProductStore();
const teamStore = useTeamStore();
const auth = useAuthStore();
const { userData } = storeToRefs(auth);
const emcRequestStore = useEmcRequestStore();
const { notificationCount } = storeToRefs(emcRequestStore);
import "@/pinia/echo";
import { toast } from "vue3-toastify";

const newNotification = ref(false);
const props = defineProps({
  openSidebar: {
    type: Function,
  },
  closeSidebar: {
    type: Function,
  },
});

onMounted(async () => {
  profileData.value = await useAuthStore().getProfile();
  newNotification.value = userData.value.new_notifications;

  const id = userData.value.id || null;
  const team_id = userData.value.team_id || null;

  Echo.private(`App.Models.User.${id}`).listen(".user.notification", (e) => {
    newNotification.value = true;
    // console.log("Notification event:", e);
    const payloadFormat =
      Array.isArray(e.format) && e.format.length
        ? e.format
        : [{ type: "text", content: e.description }];

    // ถ้ากลัว e มี proxy/ชนิดแปลก ๆ ใช้ structuredClone ก็ได้
    const safeE = structuredClone
      ? structuredClone(e)
      : JSON.parse(JSON.stringify(e));

    toast(
      h(ToastNotification, {
        title: e.title,
        format: payloadFormat,
        payload: safeE,
        onDetail: async (data) => {
          //

          if (data.event_type == "damaged") {
            // 1. แจ้งเตือนสาธารณประโยชน์ที่ได้รับความเสียหาย -> ไปหน้า dashboard + popup ตาม type
            const body = {
              type: data.related_data?.type, // 1,2,3,4
              popup_name: "damaged",
            };
            localStorage.setItem("popup", JSON.stringify(body));
            router.push({
              path: "/dashboard",
              query: {
                popup: data.related_data?.type,
                ts: Date.now(),
              },
            });
          } else if (data.event_type == "product_request") {
            // 2. แจ้งเตือนคำร้องขอทรัพยากรส่วนกลาง -> ไปหน้า resource
            if (data.event_action == "created") {
              const res = await productStore.getProductRequestById(
                data.related_data?.product_id
              );
              const body = {
                ...res?.data?.data,
                popup_name: "created",
              };
              localStorage.setItem("popup", JSON.stringify(body));
              router.push({
                path: "/dashboard",
                query: {
                  popup: "created",
                  ts: Date.now(),
                },
              });
            }
          } else if (data.event_type == "product") {
            // 3. แจ้งเตือนได้รับทรัพยากรส่วนกลาง -> ไปหน้า resource
            if (data.event_action == "received") {
              localStorage.setItem("popup", JSON.stringify("received"));
              router.push({
                path: "/resource",
                query: {
                  popup: "received",
                  ts: Date.now(),
                },
              });
            }
          } else if (data.event_type == "shelter_product") {
            // 4. แจ้งเตือนได้รับทรัพยากรภายในศูนย์
            if (data.event_action == "received") {
              const body = {
                ...data.related_data,
                id: data.related_data?.to_shelter_id,
              };
              const name = data.related_data?.to_shelter_name;
              localStorage.setItem("shelterID", JSON.stringify(body));
              localStorage.setItem("popup", JSON.stringify("received"));
              router.push({
                path: `/shelter/${name}/resources`,
                query: {
                  popup: "received",
                  ts: Date.now(),
                },
              });
            }
          } else if (data.event_type == "emergency_request") {
            // 5. แจ้งเตือนเหตุฉุกเฉิน -> ไปหน้ารายละเอียดแจ้งเหตุฉุกเฉิน
            const id = data.entity_id;
            localStorage.setItem("emReqHistoryID", JSON.stringify(id));
            if (
              data.event_action == "created" ||
              data.event_action == "rejected"
            ) {
              router.push({
                path: `/emergency-requests/reporter-detail/${id}`,
                query: {
                  ts: Date.now(),
                },
              });
            } else if (data.event_action == "assigned") {
              router.push({
                path: `/emergency-requests/waiting-lists-reporter-detail/${id}`,
                query: {
                  ts: Date.now(),
                },
              });
            } else if (
              data.event_action == "success" ||
              data.event_action == "unsuccess"
            ) {
              router.push({
                path: `/emergency-requests/emergency-request-history/${id}`,
                query: {
                  ts: Date.now(),
                },
              });
            }
          } else if (data.event_type == "news") {
            // 6. แจ้งเตือนข่าวประชาสัมพันธ์
            const body = {
              ...data.related_data,
              id: data.related_data?.entity_id,
            };
            const name = data.related_data?.entity_name;
            localStorage.setItem("newID", JSON.stringify(body));
            router.push({
              path: `/public-relations/${name}`,
              query: {
                ts: Date.now(),
              },
            });
          } else if (data.event_type == "shelter_news") {
            // 7. แจ้งเตือนข่าวประชาสัมพันธ์ภายในศูนย์
            const body = {
              ...data.related_data,
              id: data.related_data?.shelter_id,
            };
            localStorage.setItem("shelterID", JSON.stringify(body));
            const body1 = {
              ...data.related_data,
              id: data.related_data?.entity_id,
            };
            localStorage.setItem("newID", JSON.stringify(body1));
            router.push({
              path: `/shelter/${data.related_data?.shelter_name}/${data.related_data?.entity_name}`,
              query: {
                ts: Date.now(),
              },
            });
          } else if (data.event_type == "user") {
            // 8. แจ้งเตือนผู้ใช้งานขอลงทะเบียน
            if (data.event_action == "registered") {
              const body = {
                ...data.related_data,
                id: data.related_data?.entity_id,
              };
              const name = data.related_data.entity_name;
              localStorage.setItem("ID", JSON.stringify(body));
              router.push({
                path: `/pending-approval-list/${name}`,
                query: {
                  ts: Date.now(),
                },
              });
            }
          } else if (data.event_type == "appointment") {
            // 9. แจ้งเตือนนัดหมาย
            // if (data.event_action == "shelter") {
            if (auth.hasRole([ROLES.staff]) || data.event_action == "shelter") {
              const body = {
                ...data.related_data,
                id: data.related_data?.shelter_id,
              };
              localStorage.setItem("shelterID", JSON.stringify(body));
              const name = data.related_data?.shelter_name;
              router.push({
                path: `/shelter/${name}/medical-team-schedule`,
                query: {
                  ts: Date.now(),
                },
              });
            } else {
              router.push({
                path: `/medical-team/checkup-schedule`,
                query: {
                  ts: Date.now(),
                },
              });
            }
          } else if (data.event_type == "position") {
            // 10. แจ้งเตือนอัปเดต ระบบบัญชาการ -> dashboard + popup = position
            localStorage.setItem("popup", JSON.stringify("position"));
            router.push({
              path: `/dashboard`,
              query: {
                popup: "position",
                ts: Date.now(),
              },
            });
          } else if (data.event_type == "shelter_position") {
            // 11. แจ้งเตือนแผนผังการทำงาน ภายในศูนย์พักพิง
            const body = {
              ...data.related_data,
              id: data.related_data?.shelter_id,
            };
            localStorage.setItem("shelterID", JSON.stringify(body));
            localStorage.setItem("popup", JSON.stringify("workFlowChart"));
            router.push({
              path: `/shelter/${data.related_data?.shelter_name}`,
              query: {
                popup: "workFlowChart",
                ts: Date.now(),
              },
            });
          }
          //
        },
      }),
      {
        theme: "light",
        type: "default",
        position: "top-right",
        className: "auto-toast",
        hideProgressBar: true,
        autoClose: 6000,
        onClose: () => {
          if (e.event_type == "shelter_staff" || e.event_type == "team") {
            if (
              e.event_action == "leaved" ||
              e.event_action == "transfered" ||
              e.event_action == "joined"
            ) {
              router.push({
                path: "/dashboard",
                query: {
                  popup: "shelter_staff",
                  ts: Date.now(),
                },
              });
            }
          }
        },
        // autoClose: false,
      }
    );
  });

  Echo.private(`team.${team_id}`).listen(
    ".user.emc-notification",
    async (e) => {
      if (auth.hasRole([ROLES.team_leader, ROLES.team_member])) {
        await emcRequestStore.getEmcNotification();
      }
    }
  );

  Echo.private("admin").listen(".user.emc-notification", async (e) => {
    if (auth.hasRole([ROLES.admin])) {
      await emcRequestStore.getEmcNotification();
    }
  });

  await prefixStore.getAllPrefix();
  if (
    auth.hasRole([
      ROLES.admin,
      ROLES.staff,
      ROLES.team_leader,
      ROLES.team_member,
    ])
  ) {
    await teamStore.getAllTeam();
  }
  if (auth.hasRole([ROLES.admin, ROLES.team_leader, ROLES.team_member])) {
    await emcRequestStore.getEmcNotification();
  }
});

onUnmounted(async () => {
  const id = userData.value.id || null;
  const team_id = userData.value.team_id || null;

  Echo.leave(`App.Models.User.${id}`);
  Echo.leave(`team.${team_id}`);
  Echo.leave("admin");
});

const openProfileModal = async () => {
  ProfileModalRef.value.openModal();
  profileDropdown.value = false;
};

const refetchData = async () => {
  profileData.value = await useAuthStore().getProfile();
};

const goto = async () => {
  if (auth.hasRole([ROLES.admin])) {
    router.push("/emergency-requests/requests");
  } else if (auth.hasRole([ROLES.team_leader, ROLES.team_member])) {
    router.push("/emergency-requests/waiting-lists-for-help");
  }
};

const openNotification = async () => {
  newNotification.value = false;
  NotificationModalRef.value.openModal();
};
</script>

<style lang="scss" scoped>
.ButtonM {
  // color: var(--text-color-text-primary, #9b237b);
  text-align: center;
  white-space: nowrap;

  /* Button/M */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}

@media (max-width: 480px) {
  .ButtonM {
    font-size: 14px;
  }
}
</style>
<style lang="scss">
.Toastify__toast {
  display: flex !important;
  padding: 10px !important;
  align-items: center !important;
  gap: 16px !important;

  // min-width: 343px;
  width: 431px;

  border-radius: 6px !important;
  border: 1px solid #dfdcdd !important;
  background: #fbeff8 !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12) !important;
}
.Toastify__toast-container {
  width: unset !important;
}
@media only screen and (min-width: 480px) {
  .Toastify__toast {
    min-width: 343px;
  }
}
@media only screen and (max-width: 480px) {
  .Toastify__toast {
    width: 100% !important;
    margin-bottom: 1rem !important;
  }
  .Toastify__toast-container {
    left: unset !important;
    right: 1em !important;
    margin: 0;
    padding: 0;
    width: 100vw;
  }
  .Toastify__toast-container--top-right {
    top: 0;
    transform: translateX(0);
    width: 93% !important;
  }
}

.Toastify__toast-body {
  padding: 0px !important;
}
.Toastify__close-button {
  position: relative;
  width: 30px;
  height: 31px;
  color: #9b237b;
  opacity: 1;
}
.Toastify__close-button > svg,
.Toastify__close-button > span {
  display: none !important;
}
.Toastify__close-button {
  opacity: 1 !important;
}
.Toastify__close-button::before {
  content: "";
  display: block;
  width: 30px;
  height: 30px;
  color: #7b1a63 !important;
  background-color: #7b1a63;
  -webkit-mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 31'><path d='M20.9296 11.1172C21.3568 10.6901 21.3568 9.99752 20.9296 9.57037C20.5025 9.14321 19.8099 9.14321 19.3828 9.57037L15 13.9531L10.6172 9.57037C10.1901 9.14321 9.49753 9.14321 9.07038 9.57037C8.64323 9.99752 8.64323 10.6901 9.07038 11.1172L13.4531 15.5L9.07037 19.8828C8.64321 20.3099 8.64321 21.0025 9.07037 21.4296C9.49752 21.8568 10.1901 21.8568 10.6172 21.4296L15 17.0469L19.3828 21.4296C19.8099 21.8568 20.5025 21.8568 20.9296 21.4296C21.3568 21.0025 21.3568 20.3099 20.9296 19.8828L16.5469 15.5L20.9296 11.1172Z' fill='%23000'/></svg>")
    no-repeat center / contain;
  mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 31'><path d='M20.9296 11.1172C21.3568 10.6901 21.3568 9.99752 20.9296 9.57037C20.5025 9.14321 19.8099 9.14321 19.3828 9.57037L15 13.9531L10.6172 9.57037C10.1901 9.14321 9.49753 9.14321 9.07038 9.57037C8.64323 9.99752 8.64323 10.6901 9.07038 11.1172L13.4531 15.5L9.07037 19.8828C8.64321 20.3099 8.64321 21.0025 9.07037 21.4296C9.49752 21.8568 10.1901 21.8568 10.6172 21.4296L15 17.0469L19.3828 21.4296C19.8099 21.8568 20.5025 21.8568 20.9296 21.4296C21.3568 21.0025 21.3568 20.3099 20.9296 19.8828L16.5469 15.5L20.9296 11.1172Z' fill='%23000'/></svg>")
    no-repeat center / contain;
}
.Toastify__close-button {
  align-self: unset !important;
}
.Toastify__close-button:hover {
  color: #7b1a63;
}
.Toastify__toast-container--top-right {
  top: 6em !important;
}

/* กล่อง toast ให้กว้างตามคอนเทนต์ แต่ไม่เกิน 90vw */
.auto-toast {
  inline-size: fit-content; /* auto width ตามเนื้อหา */
  max-inline-size: 90vw; /* กันหลุดขอบจอ */
  width: auto; /* เผื่อบางเบราว์เซอร์ */
  max-width: none;
  display: inline-flex; /* ให้หด/ยืดตามคอนเทนต์ได้ดีขึ้น */
  align-items: stretch; /* ปรับให้สูงตามเนื้อหา */
}

/* เนื้อหาข้างใน: พับบรรทัด + รองรับคำยาวๆ */
.auto-toast .Toastify__toast-body {
  white-space: pre-line; /* เคารพ \n และพับบรรทัดอัตโนมัติ */
  overflow-wrap: anywhere; /* คำติดกันยาวๆ ให้ตัดได้ */
  word-break: break-word;
}
</style>
